<template>
  <div style="
     display: flex;
    padding: 0px 20px;
    height: 100%;
    align-items: flex-end;">
   <div v-for="shourtcut in shortcuts" :key="shourtcut.id" style="position:relative;width:153px;margin-right:76px;">
     <div v-if="shourtcut.id==selectShortcutId" class="top-strip"></div>

     <div class="my-card" @click="shourtcutSelect(shourtcut.id)">
       <div class="card-title">{{ shourtcut.title }}</div>
       <div class="card-value">{{ shourtcut.count }}</div>
     </div>

   </div>

  </div>
</template>

<script>


export default {
  name: "ShortcutTool.vue",
  components:{

  },
  props:["selectShortcutIdProps","shortcuts"],
  data(){
    return {
      selectShortcutId:"all",
      // shortcuts:[
      //   {
      //     id:"all",
      //     title:"全部",
      //     count:55
      //   },
      //   {
      //     id:"invoicenotReturn",
      //     title:"已开票未回款",
      //     count:31
      //   },
      //   {
      //     id:"acceptnotInvoice",
      //     title:"已验收未开票",
      //     count:11
      //   },
      //   {
      //     id:"notClose",
      //     title:"未关闭订单",
      //     count:13
      //   }
      // ]
    }
  },


  mounted() {
    this.selectShortcutId = this.selectShortcutIdProps
  },

  watch:{
    selectShortcutIdProps(newVal){
      // console.log('selectShortcutIdProps',newVal)
      this.selectShortcutId = newVal
    }
  },

  methods:{
    shourtcutSelect(key){
      this.$emit("shourtcutSelectChange",key)
    }
  }
}
</script>

<style scoped lang="scss">
.top-strip{
  position: relative;
  height:9px;
  width:100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  top:3px;
  background:#429FFF;
}
.my-card{
  box-sizing:border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid 2px lightgrey;
  border-radius:5px;
  width: 153px;
  height: 82px;
  cursor:pointer;
  margin-right:30px;
  .card-title{
    height:23px;
    font-size:16px;
    font-weight:bold;
  }
  .card-value{
    font-size:40px;
    line-height: 50px;
  }
}
</style>
